import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { OPEN_NEW_REDEEM_DIALOG } from "../store/myRedeem/type";
import AgencyRedeemCreate from "../component/dialog/AgencyRedeemCreate";
import { getMyRedeem } from "../store/redeem/action";
import useTranslation from "../hooks/useTranslation";
import rCoin from "../assets/images/shell.png";
import coinsIcon from "../assets/images/coins.png";
import calendarIcon from "../assets/images/fill-calender.png";
import { T, pageHeader, headerTitle, headerDesc, glassCard } from "../util/theme";

export const AgencyRedeem = () => {
  const { t } = useTranslation();
  const agencyId = localStorage.getItem("agencyId");
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location?.state?.state;
  const { myRedeem } = useSelector((state) => state.redeem);

  useEffect(() => {
    if (agencyId) dispatch(getMyRedeem(agencyId));
  }, [dispatch, agencyId]);

  const handleOpenRedeem = () => {
    dispatch({ type: OPEN_NEW_REDEEM_DIALOG, payload: data });
  };

  const statusBadge = (status) => {
    if (status === 1)
      return { color: T.amber, label: t("pending") || "Pending" };
    if (status === 2)
      return { color: T.greenToggle, label: "Complete" };
    return { color: T.rose, label: t("decline") || "Declined" };
  };

  const fmtDate = (d) =>
    (d ? new Date(d) : new Date())
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");

  return (
    <div style={{ background: "transparent", minHeight: "100vh", paddingBottom: 16 }}>
      <AgencyRedeemCreate />

      <div style={{ maxWidth: 480, margin: "0 auto" }}>
        <div
          style={{
            ...pageHeader,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 12,
          }}
        >
          <div>
            <div style={headerTitle}>{t("agency_redeem")}</div>
            <div style={headerDesc}>{t("payout_request")}</div>
          </div>

          <button
            type="button"
            className="agency-white-pill"
            style={{
              fontSize: 14,
              padding: "0 18px",
              height: 38,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              gap: 4,
              flexShrink: 0,
              marginTop: 2,
            }}
            onClick={handleOpenRedeem}
          >
            <span style={{ fontSize: 16, fontWeight: 800 }}>+</span>
            {t("add")}
          </button>
        </div>

        <div
          style={{
            padding: "8px 16px 16px",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          {myRedeem && myRedeem.length > 0 ? (
            myRedeem.map((item, idx) => {
              const s = statusBadge(item.status);
              return (
                <div key={idx} style={{ ...glassCard, padding: "16px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 12,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <img src={rCoin} alt="" width={28} height={26} />
                      <span style={{ color: "#fff", fontWeight: 800, fontSize: 17 }}>
                        {item.amount || item.rCoin || 0}
                      </span>
                    </div>
                    <span
                      style={{
                        color: s.color,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        fontSize: 13,
                        fontWeight: 700,
                      }}
                    >
                      <span
                        style={{
                          width: 8,
                          height: 8,
                          backgroundColor: s.color,
                          borderRadius: "50%",
                        }}
                      />
                      {s.label}
                    </span>
                  </div>

                  <div style={{ height: 1, background: T.border, marginBottom: 12 }} />

                  <DetailRow
                    icon={
                      <img
                        src={coinsIcon}
                        alt=""
                        width={16}
                        height={16}
                        style={{ objectFit: "contain", display: "block" }}
                      />
                    }
                    label={t("coin_income")}
                    value={item.rCoin}
                  />
                  <DetailRow
                    icon={
                      <img
                        src={calendarIcon}
                        alt=""
                        width={15}
                        height={15}
                        style={{ objectFit: "contain", display: "block" }}
                      />
                    }
                    label={t("date")}
                    value={fmtDate(item.date) || "—"}
                    // value={item.date?.split(",")[0] || "—"}
                  />

                  <p
                    style={{
                      margin: "12px 0 0",
                      fontSize: 11,
                      color: T.sub,
                      lineHeight: 1.45,
                    }}
                  >
                    {item.description ||
                      "Track all host earnings and transactions in one place, and easily filter by date to view income from gifts."}
                  </p>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "55vh",
                textAlign: "center",
                border: "none",
                background: "transparent",
                color: T.sub,
              }}
            >
              <div style={{ color: "#fff", fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
                {t("no_redeem_requests")}
              </div>
              <div style={{ fontSize: 14, fontWeight: 400 }}>{t("no_items")}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const DetailRow = ({ icon, label, value }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        background: T.iconBox,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        lineHeight: 0,
      }}
    >
      {icon}
    </div>
    <span style={{ color: T.sub, fontSize: 14, flex: 1 }}>{label}</span>
    <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>{value}</span>
  </div>
);

export default AgencyRedeem;
